// extracted by mini-css-extract-plugin
export default {"canceled":"ezWPoMdWXubu3dakYUDk","messageContent":"nLPPGedGeWaAgBSK1Rd8"};